export class Profil {
    id:number=0;
    tckimlikno:number=0;
    adi:string='';
    soyadi:string='';
    aciklama:string='';
    sifreSalt:string='';
    sifreHash:string='';
    idy: number=0;
    sdy: number=0;
    idt:  Date = new Date();;
    sdt: Date = new Date();;
    dogumTarihi: Date = new Date();;
    telefon:string='';
    sonDogrulamaKodu:string='';
    ePosta:string='';
    ogrenciEPosta:string='';
    telDogrulama: boolean=false;
    ePostaDogrulama: boolean=false;
    mernisDogrulama: boolean=false;
    kullaniciTipDurum: string='';
    userUid:string='';
    kisiTipDurum:string='';
    aktif: boolean=false;
}